export enum ListLoadBehavior {
	// Start with displayed filter and automatically load list items. Default behavior.
	AUTO_LOAD = 'AUTO_LOAD',
	// Start with displayed filter and do not automatically load list items.
	NO_LOAD = 'NO_LOAD',
	// Start with hidden filter and automatically load list items.
	HIDE_FILTER = 'HIDE_FILTER',
}
